import React from 'react';
import { Skeleton } from '@acctglobal/skeleton';
import useWindowDimensions from 'src/hooks/useWindowDimensions';

const SkeletonVisualExample = () => {
  const { isMobile } = useWindowDimensions();
  
  const containerStyle = {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    maxWidth: '1200px',
    margin: '0 auto'
  };
  
  const sliderStyle = {
    display: 'flex',
    gap: '1rem',
    overflow: 'hidden',
    padding: '10px 0'
  };
  
  const cardStyle = {
    width: isMobile ? '45%' : '23%',
    padding: '10px',
    backgroundColor: '#fafafa',
    borderRadius: '8px'
  };
  
  return (
    <div style={containerStyle}>
      <div style={sliderStyle}>
        {Array.from({ length: isMobile ? 2 : 4 }).map((_, idx) => (
          <div key={idx} style={cardStyle}>
            <Skeleton 
              height={180} 
              width="100%" 
              animation 
              backgroundColor="#f5f5f5"
         
            />
            <div style={{ marginTop: '0.75rem' }}>
              <Skeleton 
                height={16} 
                width="90%" 
                animation 
                backgroundColor="#f5f5f5"
           
              />
            </div>
            <div style={{ marginTop: '0.5rem' }}>
              <Skeleton 
                height={20} 
                width="40%" 
                animation 
                backgroundColor="#f5f5f5"
            
              />
            </div>
            <div style={{ marginTop: '0.75rem' }}>
              <Skeleton 
                height={36} 
                width="100%" 
                animation 
                backgroundColor="#f5f5f5"
               
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonVisualExample;
